const isNumber = value => {
    if (typeof value === 'number') {
        return true;
    }
    if (typeof value === 'string') {
        return /^[+-]?\d+\.?\d*$/.test(value);
    }
    return false;
};

const isCurrency = value => {
    if (!isNumber(value)) {
        return false;
    }

    const checkString = typeof value === 'string' ? value : value.toString();
    const decimalPart = checkString.toString().split('.')[1];
    const decimalCount = !decimalPart ? 0 : decimalPart.length;
    return decimalCount < 3;
};

const isNotLess = (value, min) => {
    if (typeof min !== 'number') {
        throw new TypeError('min should be a number');
    }
    if (!isNumber(value)) {
        return false;
    }
    const checkNumber = typeof value === 'number' ? value : Number(value);
    return checkNumber >= min;
};

const isNotOver = (value, max) => {
    if (typeof max !== 'number') {
        throw new TypeError('max should be a number');
    }
    if (!isNumber(value)) {
        return false;
    }
    const checkNumber = typeof value === 'number' ? value : Number(value);
    return checkNumber <= max;
};

const isEmail = value => {
    return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value);
};

export default { isCurrency, isNotLess, isNotOver, isEmail };


// WEBPACK FOOTER //
// ./src/utils/validation.js